<template>
  <Transition name="slide-up">
    <div
      v-if="visible"
      class="fixed bottom-0 left-0 right-0 z-50 bg-[#041E42] text-gray-100 shadow-2xl border-t-2 border-[#2db9d6]"
    >
      <div
        class="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
      >
        <p class="text-sm leading-relaxed flex-1 text-gray-300">
          {{ t('cookie.banner.message') }}
          <RouterLink
            :to="{ name: 'CookiePolicyPage' }"
            class="inline-flex items-center gap-1 text-[#2db9d6] font-medium hover:underline transition-colors"
          >
            {{ t('cookie.banner.learnMore') }}
            <i class="pi pi-arrow-right text-xs" />
          </RouterLink>
        </p>
        <div class="flex items-center gap-2 flex-shrink-0">
          <Button
            :label="t('cookie.banner.necessaryOnly')"
            severity="secondary"
            outlined
            size="small"
            class="!border-gray-500 !text-gray-300 hover:!bg-white/10"
            @click="acceptNecessary"
          />
          <AppButton :label="t('cookie.banner.acceptAll')" size="small" @click="acceptAll" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import AppButton from '@/components/general/ui/AppButton.vue'

const { t } = useI18n({ useScope: 'global' })

const visible = ref(false)

const acceptAll = () => {
  localStorage.setItem('cookie_consent', 'all')
  visible.value = false
}

const acceptNecessary = () => {
  localStorage.setItem('cookie_consent', 'necessary')
  visible.value = false
}

onMounted(() => {
  if (!localStorage.getItem('cookie_consent')) {
    visible.value = true
  }
})
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
